var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 12,
    height: 12,
    transform: "translate(0.254 0.254)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Whatsapp",
    transform: "translate(0.028 0.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_452",
    "data-name": "Groupe 452",
    transform: "translate(-0.282 -0.282)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_330",
    "data-name": "Trac\\xE9 330",
    d: "M86.73,83.514c-.024-.011-.916-.451-1.074-.508a.617.617,0,0,0-.208-.046.354.354,0,0,0-.3.178c-.089.132-.359.448-.442.542-.011.012-.026.027-.035.027s-.146-.057-.188-.075A4.694,4.694,0,0,1,82.7,82.049a.1.1,0,0,1-.015-.035.287.287,0,0,1,.052-.062c.049-.048.1-.111.152-.173l.072-.086a.961.961,0,0,0,.145-.23l.02-.04a.416.416,0,0,0-.012-.392c-.021-.042-.4-.951-.438-1.047-.1-.23-.224-.338-.4-.338l-.069,0a2.138,2.138,0,0,0-.742.191,1.553,1.553,0,0,0-.576,1.321,2.847,2.847,0,0,0,.617,1.567l.025.037a5.81,5.81,0,0,0,2.492,2.164,4.053,4.053,0,0,0,1.505.385h0a2.353,2.353,0,0,0,.245-.014l.044,0a1.582,1.582,0,0,0,1.1-.781,1.234,1.234,0,0,0,.07-.813.563.563,0,0,0-.263-.188",
    transform: "translate(-77.54 -76.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_331",
    "data-name": "Trac\\xE9 331",
    d: "M6.226,0A5.994,5.994,0,0,0,.217,5.964,5.92,5.92,0,0,0,1.041,8.98L.009,12.025a.159.159,0,0,0,.2.2l3.175-1.009a6.019,6.019,0,0,0,8.853-5.254A5.993,5.993,0,0,0,6.226,0m0,10.685A4.761,4.761,0,0,1,3.607,9.9a.159.159,0,0,0-.135-.019l-1.59.506.513-1.515a.159.159,0,0,0-.022-.145,4.657,4.657,0,0,1-.906-2.768,4.76,4.76,0,1,1,4.76,4.721",
    transform: "translate(0.136 0.136)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.53816b6ca224820f3f8ddfaa934e2996.svg";
export { ForwardRef as ReactComponent };